import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';
import Fragments from './fragments';

export const BEHAVIOR_PARAMETER_CHANGED = gql`
  subscription behaviorParameterChanged($code: String!) {
    behaviorParameterChanged(code: $code) {
      parameter {
        ...initializationParameterItem
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${Fragments.initializationParameterItem}
  ${CommonFragments.messageHeaders}
`;

export const INITIALIZATION_PARAMETER_CHANGED = gql`
  subscription initializationParameterChanged($code: String!) {
    initializationParameterChanged(code: $code) {
      parameter {
        ...initializationParameterItem
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${Fragments.initializationParameterItem}
  ${CommonFragments.messageHeaders}
`;

export const HEALTH_CHECKS_COMPLETED = gql`
  subscription healthChecksCompleted($serviceName: String!) {
    healthChecksCompleted(serviceName: $serviceName) {
      parameters {
        parameterCode
        isInitializationParam
        status
        errorMessage
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const PARAMETER_VALIDATION_FAILED = gql`
  subscription parameterValidationFailed($code: String!) {
    parameterValidationFailed(code: $code) {
      paramCode
      status
      errorMessage
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
